.create-new-pipeline-form {
    display: flex;
    margin: 8px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}
